import { config } from "../config";

/** Uploaded images live on the public website, including during local development. */
export function frameImageUrl(image?: string | null): string {
  const value = image?.trim();
  if (!value) return "/static/img/gal12.jpg";
  if (/^https?:\/\//i.test(value)) return value;
  const imagePath = value.startsWith("/") ? value : value.startsWith("gallery/") ? `/${value}` : `/gallery/${value}`;
  const base = config.imageBaseUrl;
  return new URL(imagePath, base).href;
}
